import { render, staticRenderFns } from "./get.vue?vue&type=template&id=31df89a0&scoped=true&"
import script from "./get.vue?vue&type=script&lang=js&"
export * from "./get.vue?vue&type=script&lang=js&"
import style0 from "./get.vue?vue&type=style&index=0&id=31df89a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df89a0",
  null
  
)

export default component.exports